import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { ConfirmNotApplicableDialogContent } from './ConfirmNotApplicableDialogContent'

interface IProps {
  isShowDialog: boolean
  category: string
  onConfirm: () => void
  onClose: () => void
}

export const ConfirmNotApplicableDialog = ({
  isShowDialog,
  category,
  onConfirm,
  onClose,
}: IProps) => {
  const contentProps = useMemo(() => {
    return { category, onConfirm, onClose }
  }, [category, onConfirm, onClose])

  return (
    <ModalDialog
      size={'xs'}
      show={isShowDialog}
      content={ConfirmNotApplicableDialogContent}
      contentProps={contentProps}
      onClose={onClose}
    />
  )
}
